// extracted by mini-css-extract-plugin
export var messageSideLeft = "_o2-1";
export var stateContainer = "_o2-0";